import { DatePicker } from './DatePicker';
import { RangeDatePicker } from './RangeDatePicker';
DatePicker.RangePicker = RangeDatePicker;
export default DatePicker;
